import { Box, Image, Text } from "@chakra-ui/react";
import React from "react";
import { GrLocation } from "react-icons/gr";
// GrLocation

const Testimonails = () => {
  return (
    <Box
      minH="90vh"
      //   bgColor={"#05CEA1"}
      display="flex"
      justifyContent={"space-evenly"}
      alignItems="center"
      flexWrap={"wrap"}
      flexDirection="column"
      px="28"
      py="10"
    >
      <Text fontSize={"4xl"} mb="10" mt="3">
        People Are Loving Products From StreetSeller
      </Text>
      <Box
        display="flex"
        justifyContent={"space-evenly"}
        alignItems="center"
        flexWrap={"wrap"}
      >
        <Box
          border="2px"
          m="2"
          w="25vw"
          p="5"
          rounded="md"
          boxShadow={"8px 8px rgba(0,0,0,0.7)"}
        >
          <Box display="flex" justifyContent={"flex-start"} alignItems="center">
            <Image
              mr="3"
              borderRadius="90%"
              boxSize="75px"
              src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
            />
            <Box display="flex" flexDirection={"column"}>
              <Text>Naman Kumar</Text>
              <Text>School Teacher </Text>
            </Box>
          </Box>
          <Text fontSize={"sm"} my="3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta non
            laudantium aperiam eum! Temporibus quibusdam nisi accusamus vitae
            recusandae. Quaerat.
          </Text>
          <Box mt="3" display="flex" fontSize={"xs"}>
            <GrLocation size={20} />
            <Text>Noida sector 62</Text>
          </Box>
        </Box>
        <Box
          border="2px"
          m="2"
          w="25vw"
          p="5"
          rounded="md"
          boxShadow={"8px 8px rgba(0,0,0,0.7)"}
        >
          <Box display="flex" justifyContent={"flex-start"} alignItems="center">
            <Image
              mr="3"
              borderRadius="90%"
              boxSize="75px"
              src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
            />
            <Box display="flex" flexDirection={"column"}>
              <Text>Naman Kumar</Text>
              <Text>School Teacher </Text>
            </Box>
          </Box>
          <Text fontSize={"sm"} my="3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta non
            laudantium aperiam eum! Temporibus quibusdam nisi accusamus vitae
            recusandae. Quaerat.
          </Text>
          <Box mt="3" display="flex" fontSize={"xs"}>
            <GrLocation size={20} />
            <Text>Noida sector 62</Text>
          </Box>
        </Box>
        <Box
          border="2px"
          m="2"
          w="25vw"
          p="5"
          rounded="md"
          boxShadow={"8px 8px rgba(0,0,0,0.7)"}
        >
          <Box display="flex" justifyContent={"flex-start"} alignItems="center">
            <Image
              mr="3"
              borderRadius="90%"
              boxSize="75px"
              src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
            />
            <Box display="flex" flexDirection={"column"}>
              <Text>Naman Kumar</Text>
              <Text>School Teacher </Text>
            </Box>
          </Box>
          <Text fontSize={"sm"} my="3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta non
            laudantium aperiam eum! Temporibus quibusdam nisi accusamus vitae
            recusandae. Quaerat.
          </Text>
          <Box mt="3" display="flex" fontSize={"xs"}>
            <GrLocation size={20} />
            <Text>Noida sector 62</Text>
          </Box>
        </Box>
        <Box
          border="2px"
          m="2"
          w="25vw"
          p="5"
          rounded="md"
          boxShadow={"8px 8px rgba(0,0,0,0.7)"}
        >
          <Box display="flex" justifyContent={"flex-start"} alignItems="center">
            <Image
              mr="3"
              borderRadius="90%"
              boxSize="75px"
              src="https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
            />
            <Box display="flex" flexDirection={"column"}>
              <Text>Naman Kumar</Text>
              <Text>School Teacher </Text>
            </Box>
          </Box>
          <Text fontSize={"sm"} my="3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta non
            laudantium aperiam eum! Temporibus quibusdam nisi accusamus vitae
            recusandae. Quaerat.
          </Text>
          <Box mt="3" display="flex" fontSize={"xs"}>
            <GrLocation size={20} />
            <Text>Noida sector 62</Text>
          </Box>
        </Box>
        <Box
          border="2px"
          m="2"
          w="25vw"
          p="5"
          rounded="md"
          boxShadow={"8px 8px rgba(0,0,0,0.7)"}
        >
          <Box display="flex" justifyContent={"flex-start"} alignItems="center">
            <Image
              mr="3"
              borderRadius="90%"
              boxSize="75px"
              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80 "
            />
            <Box display="flex" flexDirection={"column"}>
              <Text>Naman Kumar</Text>
              <Text>School Teacher </Text>
            </Box>
          </Box>
          <Text fontSize={"sm"} my="3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta non
            laudantium aperiam eum! Temporibus quibusdam nisi accusamus vitae
            recusandae. Quaerat.
          </Text>
          <Box mt="3" display="flex" fontSize={"xs"}>
            <GrLocation size={20} />
            <Text>Noida sector 62</Text>
          </Box>
        </Box>
        <Box
          border="2px"
          m="2"
          w="25vw"
          p="5"
          rounded="md"
          boxShadow={"8px 8px rgba(0,0,0,0.7)"}
        >
          <Box display="flex" justifyContent={"flex-start"} alignItems="center">
            <Image
              mr="3"
              borderRadius="90%"
              boxSize="75px"
              src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
            />
            <Box display="flex" flexDirection={"column"}>
              <Text>Naman Kumar</Text>
              <Text>School Teacher </Text>
            </Box>
          </Box>

          <Text fontSize={"sm"} my="3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta non
            laudantium aperiam eum! Temporibus quibusdam nisi accusamus vitae
            recusandae. Quaerat.
          </Text>
          <Box mt="3" display="flex" fontSize={"xs"}>
            <GrLocation size={20} />
            <Text>Noida sector 62</Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Testimonails;
